<script>
import { computed } from 'vue'
import { useToggle } from '@vueuse/core'
import difference from 'lodash/difference'
import { useQuickConversation } from './use-quick-conversation'

export default {
  name: 'QuickConversationCandidateResponses',
  emits: ['quick-response'],
  setup (props, { emit }) {
    const [isShowAll, toggleIsShowAll] = useToggle(false)
    const { candidateResponses, candidateResponsesClicked } = useQuickConversation()

    const candidateResponsesFiltered = computed(() => {
      return difference(candidateResponses.value, candidateResponsesClicked.value)
    })

    const candidateResponsesDisplayed = computed(() => {
      if (isShowAll.value) {
        return candidateResponsesFiltered.value
      }

      return candidateResponsesFiltered.value.slice(0, 3)
    })

    const onQuickRespond = (response) => {
      candidateResponsesClicked.value = [
        ...candidateResponsesClicked.value,
        response
      ]

      emit('quick-response', response)
    }

    return {
      candidateResponsesFiltered,
      candidateResponsesDisplayed,
      onQuickRespond,
      isShowAll,
      toggleIsShowAll
    }
  }

}
</script>

<template>
  <div class="d-flex d-md-block flex-column text-center position-relative">
    <button
      v-for="response in candidateResponsesDisplayed"
      :key="response"
      type="button"
      class="btn btn-outline-light btn-sm btn-block font-size-16px text-dark"
      @click="onQuickRespond(response)"
    >
      {{ response }}
    </button>
    <button
      v-if="candidateResponsesFiltered.length > 3"
      class="btn btn-outline-light btn-sm btn-block font-size-16px text-dark"
      type="button"
      :class="{'active': isShowAll}"
      @click="toggleIsShowAll()"
    >
      <i class="fal fa-ellipsis p-0 font-size-inherit" />
    </button>
  </div>
</template>
